import en from './en';

export const sharedTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
